
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { AgregarAnexosExhortoRecibidoParams, AgregarPartesExhortoRecibidoParams, BuscarExhortoRecibidoParams, BuscarExhortoRecibidoResponse, GenerarExhortoRecibidoParams, GenerarExhortoRecibidoResponse } from '../../interfaces/comun/ExhortoRecibidoInterface';

export const AgregarPartesExhortoRecibido = ( params: AgregarPartesExhortoRecibidoParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/ExhortoRecibido/AgregarPartes', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const AgregarAnexosExhortoRecibido = ( params: AgregarAnexosExhortoRecibidoParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/ExhortoRecibido/AgregarAnexos', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const GenerarExhortoRecibido = ( params: GenerarExhortoRecibidoParams ) => {

    return new Promise<GenerarExhortoRecibidoResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/ExhortoRecibido/GenerarExhortoRecibido', params, token)
            .then( ({ data } : { data : GenerarExhortoRecibidoResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const BuscarExhortoRecibido = ( params: BuscarExhortoRecibidoParams ) => {

    return new Promise<BuscarExhortoRecibidoResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/ExhortoRecibido/BuscarExhortoRecibido', params, token)
            .then( ({ data } : { data : BuscarExhortoRecibidoResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                    idExhortoRecibido: 0,
                    numeroFolio: '',
                    numeroExhorto: '',
                    numeroExpedienteOrigen: '',
                    idTipoJuicio: 0,
                    tipoJuicio : '',
                    idAutoridadExhorto: 0,
                    autoridadExhorto: '',
                    actor: [],
                    demandado: [],  
                    cuantia: '',
                });
            });
        }

    });

}